export default __webpack_public_path__ + "static/media/Instagram_green.6898b533.svg";